<template>
    <div class="home">
        <div class="map-wrap">
            <!--<swiper :options="swiperOption" ref="mySwiper" v-if="bannerList.length">-->
            <!--<swiper-slide-->
            <!--v-for="item in bannerList"-->
            <!--:key="item.id"-->
            <!--&gt;-->
            <div class="banner-content-wrap" style="position: relative">
                <div :style="{transform: `translate3d(-${currentIndex*100}%,0,0)`}" style="display: flex">
                    <div
                            class="banner-content"
                            v-for="(item,index) in bannerList"
                            style="position: relative;overflow: hidden"
                            :key="item.id"
                            v-show="bannerList.length"
                    >
                        <div :style="{ backgroundImage: `url(${item.imgPath})` }"
                             :class="{'banner-content-img':index===currentIndex,}"
                             style="background-repeat: no-repeat;background-size: cover;position: absolute;left: 0;right: 0;bottom: 0;top: 0;">
                        </div>
                        <div style="position: relative">
                            <h3
                                    class="h1 ani animated"
                                    swiper-animate-effect="bounceIn"
                            >
                                定义金融、矿业法律服务新坐标
                            </h3>
                            <!--<div class="h1-line"></div>-->
                        </div>
                        <h1
                                class="h1 ani animated"
                                swiper-animate-effect="bounceIn"
                                :class="{
							'fadeInUp':index===currentIndex&&index===0,
							'fadeInLeft':index===currentIndex&&index===1,
							'fadeInRight':index===currentIndex&&index===2,
							}">{{ item.title }}</h1>

                        <h2
                                class="animated"
                                v-html="item.remark"
                                :class="{
							'fadeInUp2':index===currentIndex&&index===0,
							'fadeInLeft2':index===currentIndex&&index===1,
							'fadeInRight2':index===currentIndex&&index===2,
							}"
                        ></h2>
                    </div>
                </div>

                <div class="swiper-button-prev" slot="button-prev" @click="handleBanner('prev')">‹</div>
                <div class="swiper-button-next" slot="button-next" @click="handleBanner('next')">›</div>
            </div>

            <!--</swiper-slide>-->

            <!--</swiper>-->
            <!-- <el-carousel :interval="5000" arrow="always">
                <el-carousel-item
                    v-for="item in bannerList"
                    :key="item.id"
                    :style="{ backgroundImage: `url(${item.imgPath})` }"
                    style="background-repeat: no-repeat;background-size: cover"
                >
                    <div class="banner-content">
                        <h1>{{ item.title }}</h1>
                        <h2>{{ item.remark }}</h2>
                    </div>
                </el-carousel-item>
            </el-carousel> -->
            <div class="news-wrap">
                <h2>
                    <span>新闻</span>
                    中心
                    <br/>
                    <p style="font-weight: normal;">news</p>
                </h2>
                <div class="news-menu">

                    <!--  <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane
                        :label="item.menuName" :name="item.menuId" v-for="(item,index) in newsMenu" :key="index">
                        </el-tab-pane>
                    </el-tabs> -->
                    <ul class="news-btn">
                        <li v-for="(item, index) in newsMenu" :key="index" @click="handleClick(item,index)">
                            <div v-if="index === 0">
                                <img src="../assets/images/世航动态选中备份.png" alt="" v-if="activeName !== item.menuId"/>
                                <img src="../assets/images/世航动态选中.png" alt="" v-else/>
                            </div>
                            <div v-if="index === 1">
                                <img src="../assets/images/世航业绩未选中.png" alt="" v-if="activeName !== item.menuId"/>
                                <img src="../assets/images/世航业绩选中.png" alt="" v-else/>
                            </div>
                            <div v-if="index === 2">
                                <img src="../assets/images/视频专栏未选中.png" alt="" v-if="activeName !== item.menuId"/>
                                <img src="../assets/images/视频专栏选中.png" alt="" v-else/>
                            </div>
                            <span>{{ item.menuName }}</span>
                        </li>
                    </ul>
                </div>
                <div class="research">
                    <div class="before"
                         :style="{right: (3-(newsIndex+1))*33.3333 + '%',left: (newsIndex)*33.3333 + '%'}"></div>
                    <ul>
                        <li v-for="(item, index) in newsList" v-if="index < 3" :key="item.id"
                            @click="linkDetail(item.id)">
                            <div class="wrap">
                                <div class="left" v-if="item.imgPath" style="overflow: hidden"><img :src="item.imgPath"
                                                                                                    alt=""
                                                                                                    style="width: 100%"/>
                                </div>
                                <div style="width: 100%;" :style="{ 'margin-left': item.imgPath ? '20px' : 0 }">
                                    <h3 class="article-title">{{ item.title }}</h3>
                                    <p class="article-intro">{{ item.summary }}</p>
                                    <div class="research-top">
										<span class="article-category" v-if="item.manList && item.manList.length">
											作者：
											<span v-for="item2 in item.manList"
                                                  :key="item2.id">{{ item2.name }}&nbsp;</span>
										</span>
                                        <span class="article-date" v-if="item.publishTime">时间：{{item.publishTime.slice(0,10)}}</span>
                                    </div>

                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="more-btn">
                    <el-button type="primary" plain round @click="linkMore">+ 查看更多</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import {requestBanner, requestMenu, requestArticleList} from '@/api/index.js'
	import {mapGetters} from 'vuex'
	import {WOW} from 'wowjs'
	import 'swiper/dist/css/swiper.css'
	import $ from 'jquery'
	import {swiper, swiperSlide} from 'vue-awesome-swiper'

	let setInt


	export default {
		components: {
			// achievementCom,
			// echartsMap
			swiper, swiperSlide
		},
		name: 'home',
		// directives: {clickoutside},
		data() {
			let that = this
			let current = 1
			return {
				imgUrl: [],
				qrCode: '',
				list: [],
				about: '',
				memberList: [],
				img: '',
				newsRoute: {},
				newsRoute2: {},
				aboutRoute: {},
				teamRoute: {},
				teamRoute2: {},
				contact: {},
				currentMap: {title: '', list: []},
				num: 0,
				currentData: [],
				bannerList: [],
				activeName: '',
				newsMenu: [],
				newsList: [],
				newsMenuId: '',
				newsIndex: 0,
				currentIndex: 0,
			}
		},
		computed: {
			...mapGetters(['doneNav'])
		},
		methods: {
			handleBanner(method, auto) {
				if (!auto) {
					clearInterval(setInt)
				}
				if (method === 'next') {
					if (this.currentIndex < this.bannerList.length - 1) {
						this.currentIndex += 1
					} else {
						this.currentIndex = 0
					}
				} else if (method === 'prev') {
					if (this.currentIndex === 0) {
						this.currentIndex = this.bannerList.length - 1
					} else {
						this.currentIndex -= 1
					}
				}

			},
			linkMore() {
				window.scrollTo(0,0);
				this.$router.push({name: 'news', query: {menuId: this.newsMenuId, id: this.activeName}})

			},
			linkDetail(manId) {
				this.$router.push({name: 'news', query: {menuId: this.newsMenuId, manId: manId}})
			},
			handleClick(item, index) {
				this.newsIndex = index
				this.activeName = item.menuId
				this.getNewList(item.menuId)
			},
			requestBanner() {
				requestBanner()
					.then(res => {
						this.bannerList = res.data
                        if (document.body.clientWidth<1000) {
	                        this.bannerList = this.bannerList.map(t=>{
	                        	t.remark = t.remark.replace("<br>","")
		                        return t
                            })
                        }
						this.$nextTick(() => {
							// this.$refs.mySwiper.swiper.autoplay.start()

						})
					})
					.catch(err => {
						console.log(err)
					})
			},
			handleClose() {
				if (this.currentMap.list && this.currentData) {
					this.currentMap.list = []
					this.currentData = []
				}
			},
			numFun(startNum, maxNum) {
				var that = this
				let numText = startNum
				let golb // 为了清除requestAnimationFrame
				function numSlideFun() {
					// 数字动画
					numText += 2 // 速度的计算可以为小数 。数字越大，滚动越快
					if (numText >= maxNum) {
						numText = maxNum
						cancelAnimationFrame(golb)
					} else {
						golb = requestAnimationFrame(numSlideFun)
					}
					that.num = numText
				}

				numSlideFun() // 调用数字动画
			},
			// handleMouse(param) {
			// 	for (let i=0;i<this.list.length;i++) {
			// 		if (this.list[i].menuName===param.name) {
			// 			this.getCurrentMap(this.list[i].menuId,param.name)
			// 		}
			// 	}
			// },
			getCurrentMap(id, title) {
				this.axios
					.get('website/article/list', {
						params: {
							menuId: id,
							page: 1,
							pageSize: 1000
						}
					})
					.then(res3 => {
						this.currentData = [{name: title, value: '0'}]
						this.currentMap.list = res3.data
						this.currentMap.title = title
					})
			},
			requestArticeList() {
				this.axios.get('website/menu/treelist').then(res => {
					this.newsRoute = {name: 'news', query: {menuId: res.data[4].menuId}}
					this.newsRoute2 = {name: 'news', query: {menuId: res.data[4].menuId}}
					this.aboutRoute = {name: 'about', query: {menuId: res.data[1].menuId}}
					this.teamRoute = {name: 'team', query: {menuId: res.data[2].menuId}}
					this.teamRoute2 = {name: 'team', query: {menuId: res.data[2].menuId}}
					this.axios
						.get('website/menu/treelist', {
							params: {
								menuId: res.data[0].menuId,
								page: 1,
								pageSize: 1000
							}
						})
						.then(res2 => {
							this.getSettings()
							this.list = res2.data
							// this.getCurrentMap(res2.data[0].menuId,res2.data[0].menuName)
						})
					// this.axios.get('website/single/info', {params: {menuId: res.data[1].menuId}}).then(res => {
					// 	this.about = res.data.summary
					// 	this.img = res.data.imgPath
					// })
					this.axios.get('website/member/list', {params: {menuId: res.data[3].menuId}}).then(res => {
						this.memberList = res.data
					})
				})
			},
			getSettings() {
				this.axios.get(`/website/setting/info`, {params: {settingKey: 'qrCode'}}).then(res => {
					this.qrCode = res.data.settingValue
				})
				this.axios.get('website/contactus/info', {params: {menuId: this.doneNav[6].menuId}}).then(res => {
					this.contact = res.data
				})
			},
			getNewList(menuId) {
				requestArticleList({menuId: menuId}).then(res => {
					this.newsList = res.data
				})
			}
		},
		mounted() {
			var wow = new WOW({
				live: false
			})
			wow.init()
			setInt = setInterval(() => {
				this.handleBanner('next', true)
			}, 10000)

		},
		created() {
			this.requestArticeList()
			this.numFun(0, 200)
			this.requestBanner()
			requestMenu().then(res => {
				this.activeName = res.data[2].subList[0].menuId
				this.newsMenu = res.data[2].subList
				this.newsMenuId = res.data[2].menuId
				this.getNewList(this.newsMenu[0].menuId)
			})
			// this.axios.get('website/contactus/info')
			// 	.then(res => {
			// 		this.contact = res.data
			// 		this.contact.lng = Number(this.contact.map.split(',')[0])
			// 		this.contact.lat = Number(this.contact.map.split(',')[1])
			// 	})
		}
	}
</script>

<style lang="scss" scoped>
    .more-btn {
        line-height: 120px;
        text-align: center;
        text-decoration: underline;
        font-size: 18px;
        width: 1200px;
        margin: 0 auto;
        padding-left: 10px;
        color: $theme-color;
        padding-bottom: 100px;

        span {
            &:hover {
                color: #5a5a5a;
            }
        }
    }

    .news-menu {
        width: 1200px;
        margin: 0 auto;
    }

    .swiper-container-horizontal > .swiper-pagination-bullets {
        bottom: 0;
    }

    .swiper-container {
        overflow-y: auto;
    }

    .banner {
        width: 100%;
        height: 100%;
        background: no-repeat;
        background-size: cover;
        background-position: 50%;
    }

    .video {
        width: 368px;
        height: 206px;
        background-image: url('https://image.lanshilaw.com/img/website/2018/11/20181126175645658365.png');
        background-size: cover;
        cursor: pointer;
        position: relative;

        &:hover {
            box-shadow: 2px 2px 10px 1px rgba(0, 0, 0, 0.3);
        }

        .mask {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);

            .mask-bottom {
                z-index: 33;
                position: absolute;
                width: 100%;
                height: 40px;
                line-height: 40px;
                background-color: rgba(0, 0, 0, 0.5);
                bottom: 0;
                left: 0;
                right: 0;
                font-size: 18px;
                color: #fff;
                padding-left: 10px;
                box-sizing: border-box;
            }
        }
    }

    .content {
        width: 1100px;
        margin: 40px auto;
        margin-bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;

        img {
            width: 105px;
            height: 69px;
        }
    }

    .swiper-container {
        // margin-left: 24px;
    }

    .ad {
        height: 150px;
        line-height: 150px;
        width: 100%;
        margin-bottom: 60px;
        background-color: $theme-color;
        background-image: url(data:image/png;base64,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);
        background-position: 50%;
        background-size: cover;

        .num {
            font-size: 30px;
            color: #fff;
            margin: 0 24px;
            text-align: center;
        }
    }

    .perfor-box {
        padding-bottom: 30px;
    }

    .perfor-title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;

        .sm-title {
            display: inline-block;
            font-size: 22px;
            color: #353535;
            border-left: 4px solid $theme-color;
            padding-left: 10px;
            height: 22px;
            line-height: 22px;
            margin-top: 4px;
        }

        .mores {
            color: $theme-color;
            font-size: 14px;
            display: inline-block;
            height: 36px;
            line-height: 36px;
            padding: 0 12px;
            cursor: pointer;

            &:hover {
                border-radius: 5px;
                background-color: $theme-color;
                box-shadow: 0 3px 5px 0 rgba(36, 70, 111, 0.3);
                font-size: 14px;
                color: #fff;
            }
        }
    }

    .flow {
        background-color: #f6f8f9;
        padding: 28px 10px;
        box-sizing: border-box;
        height: 420px;

        .perfor-title {
            padding: 10px;
        }
    }

    .perfor-left {
        width: 66%;
        padding: 10px;
        min-height: 530px;
    }

    .perfor-right {
        width: 33%;
        padding: 10px;
        margin-bottom: 20px;

        p {
            font-size: 14px;
            line-height: 25px;
        }
    }

    .member-wrap {
        /*width: 144px;*/
        margin-right: 30px;
        overflow: hidden;
    }

    .team-block {
        padding: 0 20px;
        text-align: center;
        cursor: pointer;

        .team-avtar {
        }

        img {
            max-width: 90px;
        }
    }

    .team-text {
        span {
            font-size: 40px;
            font-weight: bold;
            margin-right: 5px;
            line-height: 20px;
            color: $theme-color;
        }

        h3 {
            text-transform: uppercase;
            text-align: center;
            letter-spacing: 0.1em;
            margin-top: 30px;
            margin-bottom: 13px;
            line-height: 1;
        }

        h6 {
            margin-top: 0;
            margin-bottom: 15px;

            text-align: center;
            line-height: 1;
        }

        a {
            color: #151826;
        }
    }

    .map {
        width: 50%;
        height: 250px;
    }

    .contact-us {
        min-height: 310px;

        ul {
            color: #888;
            font-size: 14px;
            line-height: 40px;
            margin-left: 20px;
        }
    }

    .map-wrap {
        background-color: #f3f3f3;
        position: relative;
        // height: calc(100vh - 151px);
    }

    .content-right-banner {
        z-index: 999;
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 450px;
        height: 100%;

        > div {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            margin-top: 80px;
            padding-top: 20px;
            margin-left: -20%;
            margin-right: 40px;
            background-color: #fff;
            height: 250px;
        }
    }

    .content-right {
        width: 50%;

        .team-block {
            text-align: left;
        }

        h6 {
            line-height: 30px;
            text-align: left;
            font-size: 26px;
            padding-left: 30px;
            margin-bottom: 20px;
            color: #df9e2e;

            img {
                margin-top: -2px;
            }
        }
    }

    .content-left {
        > img {
            position: absolute;
            left: 71px;
            top: 102px;
            width: 421px;
        }

        .content-left-bottom {
            position: absolute;
            bottom: 207px;
            left: 154px;
            text-align: center;

            > p {
                margin-top: 30px;
                font-size: 20px;

                span {
                    color: $theme-color;
                }
            }

            .content-left-bottom-top {
                margin: 0 auto;
                position: relative;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                width: 213px;
                height: 200px;
                display: flex;
                justify-content: center;
                flex-direction: column;

                img {
                    width: 74px;
                    position: absolute;
                    top: -37px;
                    left: 68px;
                }

                text-align: center;
                border-bottom: 13px solid #003267;

                span {
                    font-size: 32px;
                }

                p {
                    color: $theme-color;
                    font-size: 18px;
                }
            }
        }
    }

    .content-qrCode {
        position: absolute;
        right: 54px;
        bottom: 30px;
        text-align: center;

        > p {
            margin-top: 10px;
            font-size: 20px;

            span {
                color: $theme-color;
                font-size: 20px;
            }
        }

        img {
            width: 102px;
            margin-bottom: 20px;
        }

        div {
            color: $theme-color;
            font-size: 22px;
        }
    }

    .news-wrap {
        text-align: center;
        background-color: #FFFFFF;

        h2 {
            font-size: 36px;
            text-align: center;
            margin: 90px auto 30px;
            padding: 30px;

            span {
                font-weight: bold;
                color: $theme-color;
            }

            background-image: url(../assets/images/新闻中心图案.png);
            background-repeat: no-repeat;
            display: inline-block;
            background-size: 50%;

            p {
                font-size: 28px;
            }
        }
    }

    .banner-content-wrap {
        height: calc(100vh - 90px) !important;
        overflow: hidden;
    }

    .banner-content {
        height: calc(100vh - 90px) !important;
        color: #ffffff;
        min-width: 100%;
        text-align: center;
        position: relative;
        text-shadow: 0 3px 10px #000;

        h3 {
            font-size: 36px;
            /*line-height: 80px;*/
            /*position: absolute;*/
            /*left: 20%;*/
            /*top: 35%;*/
            text-align: left;
            margin-top: -20vh;
            margin-left: 280px;
            margin-bottom: 20vh;
            font-weight: normal;
            z-index: 1;
            position: relative;
        }
        .h1-line {
            position: absolute;
            width: 60px;
            height: 4px;
            left: 280px;
            top: calc(-20vh - 15px);
            background-color: $theme-color;
            z-index: 6;
            padding-bottom: 0;
            box-shadow: 0 6px 10px #000;
        }
        h1 {
            font-size: 32px;
            padding-bottom: 20px;
            font-weight: bold;
        }
        h2 {
            font-size: 26px;
            font-weight: normal;
            z-index: 2;
        }

        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .news-btn {
        display: flex;
        text-align: center;
        justify-content: space-around;
        font-size: 20px;
        font-weight: bold;

        img {
            width: 85px;
        }

        li {
            cursor: pointer;
        }
    }

    .research {
        width: 1200px;
        position: relative;

    }

    .research .before {
        left: 0;
        right: 0;
        top: -2px;
        height: 2px;
        background-color: $theme-color;
        position: absolute;
    }

    .nopage {
        h1 {
            opacity: 0;
        }

        h2 {
            opacity: 0;
        }
    }

    .showpage {
        display: flex;

        h1 {
            transition: all 1s;
        }

        h2 {
            transition: all 1s;
        }
    }

    .swiper-slide-prev, .swiper-slide-next {
        h1 {
            opacity: 0;
            transition: all .4s;
        }

        h2 {
            opacity: 0;
            transition: all .4s;
        }
    }

    .fadeInUp {
        animation-name: fadeInUp;
        animation-delay: 0.5s;
    }

    .fadeInUp2 {
        animation-name: fadeInUp;
        animation-delay: 1s;
    }

    .fadeInLeft {
        animation-name: fadeInLeft;
        animation-delay: 0.5s;
    }

    .fadeInLeft2 {
        animation-name: fadeInLeft;
        animation-delay: 1s;
    }

    .fadeInRight {
        animation-name: fadeInRight;
        animation-delay: 0.5s;
    }

    .fadeInRight2 {
        animation-name: fadeInRight;
        animation-delay: 1s;
    }

    @keyframes animate {
        0% {
            transform: scale(1);
            /*opacity: 0.5;*/
        }
        /*10% {*/
        /*opacity: 1;*/
        /*}*/
        100% {
            transform: scale(1.4);
        }
    }

    @keyframes animate2 {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    .banner-content-img {
        transform: scale(1.4);
        animation: animate 15s;
    }
    @media (max-width: 992px) {
        .banner-content {
            h3 {
                margin-left: 30px;
                font-size: 26px;
                margin-bottom: 15vh;
            }
            h2 {
                padding: 0 25px;
                font-size: 22px;
            }
        }
        .banner-content .h1-line {
            left: 30px !important;
        }
        .news-wrap {
            padding: 0 20px;
        }
    }
    @media (max-width: 992px) {
        .banner-content-wrap {
            .banner-content {
                &:nth-child(1) {
                    .banner-content-img {
                        background-position: 46% 0;
                    }
                }
                &:nth-child(2) {
                    .banner-content-img {
                        background-position: 15% 0;
                    }
                }
                &:nth-child(3) {
                    .banner-content-img {
                        background-position: 77% 0;
                    }
                }
            }
        }
    }
</style>
